// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"46f10364","832":"f0660d30"}[chunkId] + ".chunk.js";
};